/* eslint-disable import/extensions */
/* eslint-disable global-require */
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2023. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */ export default {
  defaultLocale: 'en',
  locales: [
    {
      locale: 'en',
      displayName: 'English',
      localeData: require('@formatjs/intl-pluralrules/locale-data/en'),
      messages: require('../locale/messages_en'),
    },
    {
      locale: 'es',
      displayName: 'Spanish',
      localeData: require('@formatjs/intl-pluralrules/locale-data/es'),
      messages: {
        ...require('@spm/core-ui-locales/data/messages_es'),
        ...require('@spm/intelligent-evidence-gathering-locales/data/messages_es'),
        ...require('@spm/universal-access-ui-locales/data/messages_es'),
        ...require('../locale/messages_dashboard_es'),
        ...require('../locale/messages_es'),
        ...require('../locale/messages_footer_es'),
        ...require('../locale/messages_overview_es'),
        ...require('../locale/messages_userRegistration_es'),
        ...require('../locale/messages_profile_es'),
      },
    },
  ],
};
